import React, { Component, useEffect } from "react";
import { customLog } from "../../../variables/Variables";
import firebase from "../../../firebase/index";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    name: "Name:",
    email: "Email:",
    message: "Message:",
    messagePlaceholder: "Type your message",
    submit: "Submit",
  },
  ja: {
    name: "名前:",
    email: "メール:",
    message: "メッセージ:",
    messagePlaceholder: "メッセージを入力してください",
    submit: "送信",
  },
  es: {
    name: "Nombre:",
    email: "Correo electrónico:",
    message: "Mensaje:",
    messagePlaceholder: "Escribe tu mensaje",
    submit: "Enviar",
  },
});

class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      name: "",
      useremail: "",
      message: "",
      clicked: false,
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
        });
    }

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ user, name: user.displayName, useremail: user.email });
      } else {
        const { steps } = this.props;
        const userDataStep = steps["not_login_2"];
        if (userDataStep && userDataStep.value) {
          this.setState({
            name: userDataStep.value.name,
            useremail: userDataStep.value.email,
          });
        }
      }
    });
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleButtonClick = () => {
    const { name, message, useremail } = this.state;
    const email = "internjsb@gmail.com";
    this.setState({ clicked: true });

    fetch(
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/testfunctionsendemail",
      {
        method: "POST",
        body: JSON.stringify({
          name: this.state.name,
          subject: "Questions that cannot be answered by chatbot",
          message: this.state.message,
          email: this.state.useremail,
          supportType: "idk",
        }),
      }
    )
      .then(async (response) => {
        customLog(response);
        let returnedVal = await response.json();
        customLog(returnedVal);
      })
      .catch((err) => {
        customLog(err);
      });

    this.props.triggerNextStep({ value: "2ndlogin", trigger: "2ndlogin" });
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const containerStyle = {
      alignItems: "center",
      padding: "3px",
      width: "450px",
    };

    const inputStyle = {
      width: "215px",
      color: "black",
      borderRadius: "10px",
      padding: "10px",
      border: "1px solid #ccc",
    };

    const inputStyle2 = {
      width: "215px",
      height: "100px",
      color: "black",
      borderRadius: "10px",
      padding: "10px",
      border: "1px solid #ccc",
      resize: "none",
    };

    const buttonStyle = {
      width: "215px",
      height: "40px",
      marginTop: "10px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 0",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { user, name, useremail, clicked } = this.state;

    return (
      <div style={containerStyle}>
        <label htmlFor="Name">{localizationStrings.name}</label>
        <br />
        <input
          type="text"
          id="Name"
          name="name"
          value={this.state.name}
          style={inputStyle}
          readOnly
        />
        <br />
        <label style={{ marginTop: "12px" }} htmlFor="useremail">
          {localizationStrings.email}
        </label>
        <br />
        <input
          type="text"
          id="useremail"
          name="useremail"
          value={this.state.useremail}
          style={inputStyle}
          readOnly
        />
        <br />
        <label style={{ marginTop: "12px" }} htmlFor="message">
          {localizationStrings.message}
        </label>
        <br />
        <textarea
          type="text"
          id="message"
          name="message"
          value={this.state.message}
          style={inputStyle2}
          onChange={this.handleInputChange}
          disabled={clicked}
          placeholder={localizationStrings.messagePlaceholder}
        />
        <br />
        <button
          style={{
            ...buttonStyle,
            ...(clicked && buttonHoverStyle),
            ...(this.state.triggerValue === "2ndlogin"),
          }}
          onMouseEnter={() => this.setState({ isButtonHovered: true })}
          onMouseLeave={() => this.setState({ isButtonHovered: false })}
          onClick={this.handleButtonClick}
          disabled={clicked}
        >
          {localizationStrings.submit}
        </button>
      </div>
    );
  }
}

export default NotFound;
